<script>
	import Header from '$lib/components/header'

	export let theme = 'light'
	export let cls = null
	export let textAlign = 'text-left'
	export let subheadingWeight = 'bold'
	export let liner = false
	if (theme === 'dark') {
		theme = 'text-neutral-50'
	} else {
		theme = ''
	}
</script>

<div class="relative pt-10 {textAlign} {cls}">
	{#if liner}
		<div class="liner" />
	{/if}
	{#if $$slots.superheading}
		<Header.SuperHeading fontWeight="font-extrabold">
			<slot name="superheading" />
		</Header.SuperHeading>
	{/if}

	<Header.Heading cls={theme} level="2">
		<slot />
	</Header.Heading>
	{#if $$slots.subheading}
		<p class="{subheadingWeight} {theme}">
			<slot name="subheading" />
		</p>
	{/if}
</div>

<style>
	.liner {
		@apply relative left-1/2 h-2 w-16 -translate-x-1/2 bg-primary-500;
	}
</style>
